module.exports = __webpack_public_path__ + "img/gallery-3.07d63084.png";